import { useState } from "react";
import { Collapse } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import type { IAuditoriaEventoGrupo } from "@/api/space/dtos/authenticator.dto";
import { type GrupoDiaAuditoria, rotuloContagem } from "../auditoria.utils";
import CardEventoClonar from "./CardEventoClonar";
import CardEventoSalvar from "./CardEventoSalvar";

function CardEvento({ evento }: { readonly evento: IAuditoriaEventoGrupo }) {
	if (evento.tipo === "clonar_grupo_usuario") return <CardEventoClonar evento={evento} />;
	return <CardEventoSalvar evento={evento} />;
}

export default function DiaAuditoria({
	dia,
	defaultAberto,
}: {
	readonly dia: GrupoDiaAuditoria;
	readonly defaultAberto: boolean;
}) {
	const [aberto, setAberto] = useState(defaultAberto);

	return (
		<div className="rounded-md border border-border/60 bg-card/40">
			<button
				type="button"
				onClick={() => setAberto((valor) => !valor)}
				className="flex w-full items-center gap-2 px-3 py-2 text-left hover:cursor-pointer hover:bg-muted/40"
			>
				<FuseSvgIcon size={18} className="shrink-0 text-muted-foreground">
					{aberto ? "lucide:chevron-down" : "lucide:chevron-right"}
				</FuseSvgIcon>
				<span className="text-xs font-bold uppercase tracking-wide text-muted-foreground">{dia.rotulo}</span>
				<span className="ml-auto shrink-0 rounded-full bg-muted px-2 py-0.5 text-[11px] font-bold text-muted-foreground">
					{rotuloContagem(dia.eventos.length, "evento", "eventos")}
				</span>
			</button>

			<Collapse in={aberto} unmountOnExit>
				<div className="flex flex-col gap-2 px-2.5 pb-2.5">
					{dia.eventos.map((evento) => (
						<CardEvento key={evento.id} evento={evento} />
					))}
				</div>
			</Collapse>
		</div>
	);
}
